import React from "react";
import Redirect from "../../asset/images/IBA/redirect-up-arrow.svg";
import DummyMan from "../../asset/images/IBA/performerDummyicon.svg";

function TopPerformerCardChild() {
  return (
    <div className="performance-box-wrapper">
      <div className="top-title" >
        <div className="left-title"> Top Performer</div>
        <div className="icon-right">
          <img src={Redirect} alt="redirect-icon" />
        </div>
      </div>
      <div className="bottom-data">
        <div className="left-bottom-data">
          <div className="image-set-ring">
            <img src={DummyMan} alt="dummy" />
          </div>
          <span className="name-span">Avinash Shukla</span>
        </div>
        <div className="right-bottom-data">
          <div className="talk-time">
            <span>Total Talk time:</span>
            <span>1,200 Mins</span>
          </div>
          <div className="talk-time">
            <span>Total Leads:</span>
            <span>1,044</span>
          </div>
          <div className="talk-time">
            <span>Total Converted:</span>
            <span>987</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopPerformerCardChild;
